import { MessageHandlerBase } from "./MessageHandlerBase";
import { addSessionMessage } from '../../components/AlmeApp/SessionMessages';
const SwitchAccountAppEvent = "ConsumerCenterSwitchAccount";
export default class SwitchAccountHandler extends MessageHandlerBase {
    constructor() {
        super(...arguments);
        this.message = null;
    }
    handle(message) {
        this.message = message;
        if (this.almeState.history.length && !this.almeState.sessionExpired) {
            this.sendAppEvent(this.message, SwitchAccountAppEvent);
        }
        else {
            this.saveMessage();
        }
    }
    onAppEventSuccess(appEventResponse) {
        const sessionMessages = this.createSessionMessage();
        const responseEntryId = appEventResponse.extensionData.entryId;
        if (responseEntryId !== this.appConfig.history.errorResponse.entryId) {
            this.almeState.history.push(appEventResponse);
            this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { lastEntryId: responseEntryId, chatId: appEventResponse.extensionData.chatId, lastActivityTime: Date.now(), sessionMessages }));
        }
    }
    createApiParams(message) {
        return super.createApiParams(message);
    }
    onAppEventFailure(error) {
        console.error(error);
        this.saveMessage();
    }
    saveMessage() {
        const sessionMessages = this.createSessionMessage();
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { sessionMessages }));
    }
    createSessionMessage() {
        var _a;
        const message = this.message;
        const switchAccountMesssage = {
            // Account Id in platform message comes as number
            accountId: `${(_a = message.userData) === null || _a === void 0 ? void 0 : _a.accountId}`,
        };
        return addSessionMessage(this.almeState, this.appConfig.main.clientSessionId, "SwitchAccount", switchAccountMesssage);
    }
}
